import { Component, inject } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "sol-ads-business",
  standalone: true,
  template: `
    <div class="main-ad-container">
      <div class="image">
        <img
          src="../../../assets/images/ads/laptop.webp"
          alt="Sollo Business"
          draggable="false"
        />
      </div>
      <div class="description">
        <h1>{{ "ADS.BUSINESS.line1" | translate }}</h1>
        <h1 class="ft">{{ "ADS.BUSINESS.line2" | translate }}</h1>
        <h3>{{ "ADS.BUSINESS.line3" | translate }}</h3>
        <h1 class="ft">{{ "ADS.BUSINESS.line4" | translate }}</h1>
        <div class="button" (click)="learnMore()">
          {{ "ADS.learnMore" | translate }}
        </div>
      </div>
    </div>
  `,
  styles: `
    h1,
    h2,
    h3,
    h4 {
      margin: 0;
      padding: 0;
      color: #3e3e3e;
    }
    .main-ad-container {
      width: 100%;
      height: 100vh;
      background: url("../../../assets/images/topographic_bg.webp") #eeab2a;
      display: flex;
      flex-direction: column;
      background-blend-mode: color-dodge;
      background-size: 110rem;
      background-position-y: -5rem;

      .image {
        width: 90%;
      }

      .description {
        display: flex;
        flex-direction: column;
        align-items: end;
        width: 100%;
        padding-right: 15px;
        cursor: default;
        position: absolute;
        top: calc(100vh - 250px);
        right: 20px;

        .ft {
          font-weight: bold;
          font-size: 2.3rem;
          transition: all 0.5s ease-in-out;
          text-align: right;

          &:hover {
            scale: 1.2;
            color: #fff;
          }
        }
      }

      .button {
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        color: #3c3c3c;
        padding: 10px 25px;
        transition: all 0.5s ease-in-out;
        cursor: pointer;

        &:hover {
          scale: 1.2;
          background: #3c3c3c;
          color: #fff;
          box-shadow: 0px 14px 21px rgba(0, 0, 0, 0.5);
        }
      }
    }
  `,
  imports: [TranslateModule],
})
export class BusinessAdComponent {
  private translateService = inject(TranslateService);
  learnMore() {
    window.open("https://business.sollocard.com.br/", "_blank");
  }
}
